import { useCallback, useEffect, useState } from 'react'
import Link from 'next/link'
import { SCAM_ALERT } from '@/constants/scam-alert'
import useAuth from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

const storageKey = `ols-scam-alert-read-${SCAM_ALERT.announcementId}`

// localStorage が使えない環境（Safari プライベートモード等）でも表示・閉じる操作を止めない
const getReadAt = () => {
  try {
    return localStorage.getItem(storageKey)
  }
  catch {
    return null
  }
}

const saveReadAt = () => {
  try {
    localStorage.setItem(storageKey, new Date().toISOString())
  }
  catch {
    // 保存できない場合は次回訪問時に再表示されるだけなので継続する
  }
}

const ScamAlert = () => {
  const { currentUser } = useAuth()
  const [ isModalOpen, setIsModalOpen ] = useState(false)

  const isProfessional = !!currentUser?.isProfessional

  useEffect(() => {
    if (!isProfessional || !SCAM_ALERT.showModal) return
    if (getReadAt()) return
    setIsModalOpen(true)
  }, [ isProfessional ])

  const handleOpenChange = useCallback((open: boolean) => {
    if (open) return
    saveReadAt()
    setIsModalOpen(false)
  }, [])

  const handleClose = useCallback(() => {
    handleOpenChange(false)
  }, [ handleOpenChange ])

  if (!isProfessional) return null

  return (
    <>
      {SCAM_ALERT.showBanner && (
        <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200">
          ⚠️ {SCAM_ALERT.bannerMessage}
          <Link href="/contact" className="ml-2 whitespace-nowrap underline">
            お問い合わせ
          </Link>
        </div>
      )}
      {SCAM_ALERT.showModal && (
        <Dialog open={isModalOpen} onOpenChange={handleOpenChange}>
          <DialogContent>
            <DialogHeader>
              <p className="text-xs text-muted-foreground">
                {SCAM_ALERT.modalCategory}
                <span className="ml-3">{SCAM_ALERT.modalDate}</span>
              </p>
              <DialogTitle>{SCAM_ALERT.modalTitle}</DialogTitle>
            </DialogHeader>
            <div className="space-y-3 text-sm">
              <p>{SCAM_ALERT.modalLead}</p>
              <ul className="list-disc space-y-1 pl-5">
                {SCAM_ALERT.modalPoints.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </div>
            <DialogFooter className="gap-2">
              <Button variant="outline" asChild>
                <Link href="/contact" onClick={handleClose}>お問い合わせ</Link>
              </Button>
              <Button onClick={handleClose}>閉じる</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default ScamAlert
